import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './SideBar.scss';
import { IconButton, Tooltip } from '@mui/material';
import { KeyboardArrowRight, KeyboardArrowLeft } from '@mui/icons-material';
import {
	MaintainIcon,
	ExpandedIcon,
	MenuIcon,
	DashboardIcon,
	SystemIcon,
	DashboardIconActive,
	// IopassIcon,
	// IopassIconActive,
	TemplateIcon,
	TemplateIconActive,
	IopassIconNew,
	IopassIconActiveNew
} from '../../assets/icons/index';
import { IS_SIDE_BAR_TOPOLOGY_OPEN, SELECTED_NODE_TOPOLOGY } from '../../constants/topologyConstants';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Tooltip1 from '../tooltip/Tooltip';
import { AAA_SERVER_ADD_TRIGGER } from '../../constants/globalProfileConstants/aaaServerConstants';
import useTheme from '../../hooks/useTheme';
import { SWITCH_ADD_TRIGGER } from '../../constants/switchConstants';
import { ALARM_SUMMARY_VIEW_ALL_TRIGGER, AP_ADD_TRIGGER, AP_SNAPSHOT_NAVIGATION, CRITICAL_ALARM_TRIGGER, CRITICAL_ALARM_TRIGGER_AP, CRITICAL_ALARM_TRIGGER_HOME, CRITICAL_ALARM_TRIGGER_SWITCH } from '../../constants/accessPointConstants';
import { NAT_ADD_TRIGGER } from '../../constants/globalProfileConstants/natProfileConstants';
// import { SHOW_SSID_MODAL } from '../../constants/ssid/ssidConstants';
import {
	GROUP_ADD_TRIGGER,
	OPEN_CLOSE_ADD_GROUP_MODAL,
} from '../../constants/groupConstants';
import { USER_ADD_TRIGGER } from '../../constants/userConstants';
import { FIRMWARE_NAVIGATION_TRIGGERED } from '../../constants/firmwareManagementConstants/firmwareConstants';

const SidebarItem = ({
	id,
	title,
	icon,
	activeIcon,
	children,
	sidebarOpen,
	href,
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const isLocked = useSelector((state) => state.sidebarLock.isLocked);
	const triggerTourGuideModal = useSelector(
		(state) => state.tourGuide.triggerTourGuideModal
	);
	const aaaServerAddTrigger = useSelector(
		(state) => state.aaaServerTrigger.aaaServerAddTrigger
	);
	const criticalAlarm = useSelector(
		(state) => state.criticalAlarmTriggerReducer
	);
	const { critialAlarmsTriggerdSwitch, criticalAlarmTriggered, critialAlarmsTriggerdHome, alarmsSummaryViewAllTriggerd } = criticalAlarm;
	const natAddTrigger = useSelector((state) => state.natAddTrigger.natAddTrigger);
	const { color } = useTheme('LIGHT');
	const switchAddTrigger = useSelector(
		(state) => state.switchTrigger.switchAddTrigger
	);
	const apAddTrigger = useSelector((state) => state.apTrigger.apAddTrigger);
	const firmwareNavigatiorData = useSelector((state) => state.firmwareNavigatiorReducer);
	const { firmwareNavigationTriggered } = firmwareNavigatiorData;
	const navigateToSnapshot = useSelector((state) => state.apSnapshotNavigateReducer);
	
	// const displaySSIDModal = useSelector(
	// 	(state) => state.ssidTrigger.displaySSIDModal
	// );
	const groupAddTrigger = useSelector(
		(state) => state.groupTrigger.groupAddTrigger
	);
	const userAddTrigger = useSelector(
		(state) => state.userTrigger.userAddTrigger
	);

	const { critialAlarmsTriggerdAp } = criticalAlarm;

	const isHrefActive = (href) => {
		if (location.pathname === href && location.pathname === '/topology') {
			//  open side bar topology item
			// dispatch({ type: IS_SIDE_BAR_TOPOLOGY_OPEN, payload: true });
		}
		// close addAAAServer for add Captive Portal
		if (aaaServerAddTrigger && location.pathname !== '/system') {
			dispatch({ type: AAA_SERVER_ADD_TRIGGER, payload: false });
		}
		if (switchAddTrigger && location.pathname !== '/topology') {
			dispatch({ type: SWITCH_ADD_TRIGGER, payload: false });
		}
		if (apAddTrigger && location.pathname !== '/topology') {
			dispatch({ type: AP_ADD_TRIGGER, payload: false });
		}
		if (natAddTrigger && location.pathname !== '/system') {
			dispatch({ type: NAT_ADD_TRIGGER, payload: false });
		}
		// if (displaySSIDModal && location.pathname !== '/topology') {
		// 	dispatch({ type: SHOW_SSID_MODAL, payload: false });
		// }
		if (groupAddTrigger && location.pathname !== '/topology') {
			dispatch({ type: GROUP_ADD_TRIGGER, payload: false });
			dispatch({ type: OPEN_CLOSE_ADD_GROUP_MODAL, payload: false });
		}
		if (userAddTrigger && location.pathname !== '/system') {
			dispatch({ type: USER_ADD_TRIGGER, payload: false });
		}
		if (critialAlarmsTriggerdSwitch && location.pathname !== '/maintenance') {
			dispatch({ type: CRITICAL_ALARM_TRIGGER_SWITCH, payload: false });
		}
		if (critialAlarmsTriggerdHome && location.pathname !== '/maintenance') {
			dispatch({ type: CRITICAL_ALARM_TRIGGER_HOME, payload: false });
		}
		if (criticalAlarmTriggered && location.pathname !== '/maintenance') {
			dispatch({ type: CRITICAL_ALARM_TRIGGER, payload: false });
		}
		if (critialAlarmsTriggerdAp && location.pathname !== '/accessPointDashboard') {
			dispatch({ type: CRITICAL_ALARM_TRIGGER_AP, payload: false });
		}
		if (firmwareNavigationTriggered && location.pathname !== '/maintenance') {
			dispatch({ type: FIRMWARE_NAVIGATION_TRIGGERED, payload: false });
		}
		if (alarmsSummaryViewAllTriggerd && location.pathname !== '/maintenance') {
			dispatch({ type: ALARM_SUMMARY_VIEW_ALL_TRIGGER, payload: false });
		}

		return location.pathname === href;
	};

	const hasNavigatedRef = useRef(false);

	useEffect(() => {
		if (!navigateToSnapshot?.navigateToSnapshot) return;

		if (location.pathname === '/maintenance') {
			hasNavigatedRef.current = true;
			return;
		}

		if (hasNavigatedRef.current && location.pathname !== '/maintenance') {
			dispatch({ type: AP_SNAPSHOT_NAVIGATION, payload: false });
			hasNavigatedRef.current = false;
		}
	}, [location.pathname]);
	
	console.log('navigationnn', location.pathname, navigateToSnapshot?.navigateToSnapshot);
	const toggleOpen = () => {
		if (isLocked) return;
		if (!children?.length) {
			navigate(href);
		}
		// if (title == 'Template') {
		// 	dispatch({ type: IS_SIDE_BAR_TOPOLOGY_OPEN, payload: true });
		// }
		sidebarOpen && setIsOpen(!isOpen);
	};

	useEffect(() => {
		if (location.pathname != '/topology') return;
		if (!sidebarOpen) setIsOpen(false);
		dispatch({ type: IS_SIDE_BAR_TOPOLOGY_OPEN, payload: true });
	}, [sidebarOpen, location.pathname]);

	useEffect(() => {
		if (isLocked) {
			setIsOpen(true); // force closed
			dispatch({ type: IS_SIDE_BAR_TOPOLOGY_OPEN, payload: false }); // close topology sidebar
		}
	}, [isLocked]);


	return (
		<Tooltip1
			content={title == 'Topology' ? 'Templates' : title}
			type="basic"
			direction="right"
			width={
				title === 'Canvas Settings'
					? '120px'
					: title === 'io Pass Captive Portal'
						? '150px'
						: undefined
			}
			offset={-10}
			style={{ fontWeight: 'bold' }}
		>
			<div className="sidebar-item">
				<div
					className={`item-header ${isOpen ? 'open' : ''} ${isHrefActive(href) ||
						(triggerTourGuideModal && href === '/topology')
						? 'active'
						: ''
						}`}
					onClick={toggleOpen}
					style={{ backgroundColor: color.background.primary }}
				>
					{/* <span className="icon"><img src={(isOpen && (title != 'Dashboard' && title != 'About'))? ExpandedIcon: icon} alt={title} className="icon-img" /></span> */}
					{icon === 'Circular' ? (
						<div className="circular-icon">
							<div className="circular-icon">
								<div className="icon-text">
									{title
										.split(' ')
										.map((word) => word[0])
										.join('')}
								</div>
							</div>
						</div>
					) : (
						<span className="icon">
							{isOpen &&
								children?.length > 0 &&
								title !== 'Dashboard' &&
								title !== 'About' ? (
								<ExpandedIcon />
							) : isHrefActive(href) ? (
								activeIcon
							) : (
								icon
							)}
						</span>
					)}

					<span className={`title ${sidebarOpen && 'expanded'}`}>
						{sidebarOpen ? title : ''}
					</span>
				</div>
				{isOpen && (
					<div className="item-children">
						{children?.map((child) => (
							<SidebarItem
								key={child.id}
								id={child.id}
								title={child.title || child.name}
								icon={child.icon}
								// children={child.children}
								sidebarOpen={sidebarOpen}
								href={child.href}
							>
								{child.children}
							</SidebarItem>
						))}
						{/* {children?.map(child => (
						<p key={child.id}>{child.title}</p>
					))} */}
					</div>
				)}
			</div>
		</Tooltip1>
	);
};

SidebarItem.propTypes = {
	id: PropTypes.number.isRequired,
	title: PropTypes.string.isRequired,
	icon: PropTypes.node.isRequired,
	children: PropTypes.array,
	sidebarOpen: PropTypes.bool.isRequired,
	href: PropTypes.string.isRequired,
	activeIcon: PropTypes.node.isRequired,
};

const Sidebar = ({ setIsSidebarOpen, setIsOverlap }) => {
	const [sidebarOpen,] = useState(false);
	const [expandTopology, setExpandTopology] = useState(false);
	const [topologyPinned, setTopologyPinned] = useState(false);
	const isLocked = useSelector((state) => state.sidebarLock.isLocked);
	const { t } = useTranslation();
	const { color } = useTheme('LIGHT');
	const location = useLocation();
	const dispatch = useDispatch()
	// const navigate = useNavigate();
	// const triggerTourGuideModal = useSelector(
	// 	(state) => state.tourGuide.triggerTourGuideModal
	// );
	const topology = useSelector((state) => state.topology);
	const { sideBarTopologyOpen, sidebarWidth } = topology;

	const [isCollapsed, setIsCollapsed] = useState(() => {
		const savedState = localStorage.getItem('isSidebarCollapsed');
		return savedState === 'true';
	});

	const toggleSidebar = () => {
		setTooltipOpen(false);
		setIsCollapsed((prev) => {
			return !prev;
		});
	};

	const tourStep = useSelector((state) => state.tourGuideStep.tourStep);

	useEffect(() => {
		if (tourStep === 1) {
			setIsCollapsed(false);
			dispatch({ type: IS_SIDE_BAR_TOPOLOGY_OPEN, payload: true });
		} else {
			setIsCollapsed(prev => prev);
			dispatch({ type: IS_SIDE_BAR_TOPOLOGY_OPEN, payload: false });
		}
		localStorage.setItem("isCollpases", isCollapsed);
	}, [tourStep, dispatch]);

	useEffect(() => {
		if (sideBarTopologyOpen == undefined) return;
		setIsCollapsed(sideBarTopologyOpen);
	}, [sideBarTopologyOpen]);

	useEffect(() => {
		if (isCollapsed) {
			dispatch({ type: IS_SIDE_BAR_TOPOLOGY_OPEN, payload: true });
		} else {
			dispatch({ type: IS_SIDE_BAR_TOPOLOGY_OPEN, payload: false });
			if (location.pathname !== '/topology') {
				dispatch({ type: SELECTED_NODE_TOPOLOGY, payload: {} });
			}
		}
		localStorage.setItem("isSidebarCollapsed", isCollapsed);
		localStorage.setItem('isCollpases', isCollapsed)
	}, [isCollapsed]);

	const navItems = [
		{
			id: 1,
			title: t('Home Dashboard'),
			icon: <DashboardIcon />,
			activeIcon: <DashboardIconActive />,
			href: '/dashboard',
		},
		{
			id: 2,
			title: 'io Pass Captive Portal',
			icon: <IopassIconNew />,
			activeIcon: <IopassIconActiveNew />,
			href: '/iopass',
		},
		{
			id: 3,
			title: t('Templates'),
			icon: <TemplateIcon />,
			activeIcon: <TemplateIconActive />,
			href: '/template',
		},
		{
			id: 4,
			title: t('Maintenance'),
			icon: <MaintainIcon />,
			activeIcon: <MaintainIcon />,
			href: '/maintenance',
		},
		{
			id: 5,
			title: t('Canvas Settings'),
			icon: <SystemIcon />,
			activeIcon: <SystemIcon />,
			href: '/system',
		},


	];
	const [tooltipOpen, setTooltipOpen] = useState(false);
	const toggleIn = () => {
		// setSidebarOpen(false);
		// setIsSidebarOpen(true);
	};

	const toggleOut = () => {
		if (!topologyPinned) {
			// setSidebarOpen(false);
			// setIsSidebarOpen(false);
		}
		// topologyPinned ? setIsSidebarOpen(true) : setIsSidebarOpen(false);
	};

	const unPinTopology = () => {
		setExpandTopology(false);
		setTopologyPinned(false);
		// setIsOverlap(false);
	};

	// useEffect(() => {
	// 	if (triggerTourGuideModal) {
	// 		navigate('/topology');
	// 	}
	// }, [triggerTourGuideModal]);

	return location.pathname !== '/' &&
		location.pathname !== '/signin' &&
		location.pathname !== '/home' ? (
		<div
			id={"sidebar"}
			className={`sidebar ${sidebarOpen ? 'open' : 'closed'} ${tourStep === 0 ? 'highlight-tour-sidebar' : ''}`}
			onMouseEnter={toggleIn}
			onMouseLeave={toggleOut}
			style={{ backgroundColor: color.background.primary }}
		>
			<div className="sidebar-content">
				<Tooltip
					title={isCollapsed ? 'Hide Site Hierarchy' : 'View Site Hierarchy'}
					placement="right"
					open={tooltipOpen}
					onClose={() => setTooltipOpen(false)}
					componentsProps={{
						tooltip: {
							sx: {
								padding: '4px 8px',
								boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.16)',
								border: 'solid 1px #dedede',
								backgroundColor: '#fff',
								color: '#000',
								fontFamily: 'Inter-Regular',
								fontSize: '12px',
								fontWeight: 'medium',
								fontWeight: 'normal',
							},
						},
					}}
					PopperProps={{
						modifiers: [
							{
								name: 'preventOverflow',
								options: {
									boundary: 'clippingParents', // or a custom element
									padding: 8,
								},
							},
							{
								name: 'offset',
								options: {
									offset: [0, -8],
								},
							},
						],
					}}
				>
					<IconButton
						onClick={!isLocked ? toggleSidebar : undefined}
						onMouseEnter={() => !isLocked && setTooltipOpen(true)}
						className='site-icon'
						sx={{
							position: 'absolute',
							top: '6%',
							left: isCollapsed ? `${sidebarWidth + 45}px` : '44px',
							transform: 'translateY(-50%)',
							backgroundColor: isCollapsed ? '#4b0082' : '#fff',
							color: isCollapsed ? '#fff' : '#4b0082',
							border: isCollapsed ? 'none' : '2px solid grey',
							zIndex: 100000,
							transition: 'left ease-out',
							'&:hover': {
								backgroundColor: isCollapsed
									? '#320061'
									: '#f9f0ff',
							},
							width: { xs: '6px', sm: '14px', md: '22px' },
							height: { xs: '8px', sm: '14px', md: '22px' },
							fontSize: { xs: '8px', sm: '12px', md: '14px' },
						}}
					>
						{isCollapsed ? (
							<KeyboardArrowLeft fontSize="inherit" />
						) : (
							<KeyboardArrowRight fontSize="inherit" />
						)}
					</IconButton>
				</Tooltip>

				{
					expandTopology ? (
						<div
							className="sidebar-item"
							onClick={() => unPinTopology()}
						>
							<div className={`item-header`}>
								<span className="icon">{<MenuIcon />}</span>

								<span
									className={`title ${sidebarOpen && 'expanded'}`}
								>
									{sidebarOpen ? 'Menu' : ''}
								</span>
							</div>
						</div>
					) : (
						navItems.map((item) => (
							<SidebarItem
								key={item.id}
								id={item.id}
								title={item.title}
								icon={item.icon}
								activeIcon={item.activeIcon}
								// children={item.children}
								sidebarOpen={sidebarOpen}
								href={item.href}
							>
								{item.children}
							</SidebarItem>
						))
					)
				}
			</div >
		</div >
	) : (
		<></>
	);
};

Sidebar.propTypes = {
	setIsSidebarOpen: PropTypes.func.isRequired,
	setIsOverlap: PropTypes.func.isRequired,
};

export default Sidebar;

